import { createSelector } from '@reduxjs/toolkit';

const questionGroupStepProjections = {};

questionGroupStepProjections.tabs = createSelector(
    state => state.questionGroupStep.questionGroupStep.byId,
    questionGroupStepById => {
        return Object.keys(questionGroupStepById).map((item, index) => ({
            key: questionGroupStepById[item].code,
            label: questionGroupStepById[item].name,
        }));
    },
);

questionGroupStepProjections.questionGroupStepWithSmallestRank = createSelector(
    state => state.questionGroupStep.questionGroupStep.byId,
    questionGroupStepById => {
        if (Object.keys(questionGroupStepById).length === 0) {
            return null;
        }

        return Object.values(questionGroupStepById).reduce((acc, curr) => {
            return curr.rank < acc.rank ? curr : acc;
        });
    },
);

// return the available steps in an array withs its codes
questionGroupStepProjections.availableSteps = (activeTab = null) =>
    createSelector(
        state => state.questionGroupStep.questionGroupStep.byId,
        state => state.answer.answer.activeGroupStepCode,
        (questionGroupStepById, activeGroupStepCode) => {
            if (
                Object.keys(questionGroupStepById).includes(
                    activeGroupStepCode,
                ) === false
            ) {
                return [];
            }

            let hasReachedLastPartiallyGroupStep = false;
            const lastCompletedStep = Object.keys(questionGroupStepById).reduce(
                (acc, curr) => {
                    if (
                        hasReachedLastPartiallyGroupStep === false &&
                        curr === activeGroupStepCode
                    ) {
                        hasReachedLastPartiallyGroupStep = true;
                        return acc;
                    }

                    if (
                        hasReachedLastPartiallyGroupStep &&
                        curr === activeTab
                    ) {
                        return activeTab;
                    }

                    return acc;
                },
                activeGroupStepCode,
            );

            const availableItems = [];

            Object.keys(questionGroupStepById).every(key => {
                if (key !== lastCompletedStep) {
                    availableItems.push(key);
                }

                if (key === lastCompletedStep) {
                    availableItems.push(key);
                    return false;
                }

                return true;
            });

            return availableItems;
        },
    );

questionGroupStepProjections.answerFromGroupSteps = createSelector(
    state => state.answer.answer.answerFromGroupSteps,
    state => state.answer.answer.activeGroupStepCode,
    (answerFromGroupSteps, activeGroupStepCode) => {
        if (activeGroupStepCode) {
            return answerFromGroupSteps;
        } else {
            return [];
        }
    },
);
export default questionGroupStepProjections;
